export default "__VITE_ASSET__c841d519__"